<template>
    <div class="user-edit">
        <data-form title="Edit User"
                   tag="edit-user"
                   save-button-label="Save"
                   :field-model="userFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="returnRoute"
                   submit-success-message="User updated"
                   submit-error-message="Error updating User"
                   :submit-success-route="returnRoute"/>
    </div>
</template>

<script>

import Vue from 'vue'
import UserFields from '@/models/User'
import Authorization from '@/providers/Authorization'

/**
 * Page for admin to edit agency information
 */
export default Vue.extend({
    name: 'UserEdit',
    props: {
        userId: {
            type: Number,
            required: true
        },
    },
    data () {
        return {
            userFields: UserFields,
        }
    },
    computed: {
        returnRoute () {
            return this.userId ? '/user/view/' + this.userId : '/user/list'
        },
        fieldGroups () {
            const is_admin = Authorization.isSuperAdmin() || Authorization.isAdmin()
            return [
                ['id', 'email_edit', 'first_name', 'last_name', 'phone_office', 'phone_mobile'],
                (is_admin ? ['is_superadmin', 'is_admin', 'is_auditor', 'disabled'] : [])
            ]
        },
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'user', this.userId)
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'user', modelInstance)
        }
    },
    created () {
        if (this.userId) {
            this.$api.getItem(this, 'user', this.userId)
                .then((data) => {
                    this.title = data['full_name']
                    this.userInfo = data
                })
        } else {
            this.title = 'Create User'
        }
    },
})

</script>

